module.exports = __webpack_public_path__ + "static/media/9x9-rubber.a6316c8a.png";